import "./App.css";
import { Route, Routes, NavLink } from "react-router-dom";
import { motion } from "framer-motion";
import About from "./components/About";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Achievements from "./components/Achievements";
import AnimatedCursor from "react-animated-cursor";
import PhotoSection from "./components/PhotoSection";
import Menu from "./components/Menu";
import ProjectDetails from "./components/Projects/ProjectDetails";
import ReactParallaxTilt from "react-parallax-tilt";
// import bg from "./components/4672461_10435.jpg";
import Intro from "./Intro";
import { useState, useEffect } from "react";

function App() {
  const [showIntro, setShowIntro] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowIntro(false);
    }, 1800);

    return () => clearTimeout(timer);
  }, []);
  return (
    <div className="">
      <Intro />
      {!showIntro && (
        <div className="bg-black p-3 max-w-screen min-h-screen">
          <motion.div
            className=" bg-gray-900 rounded-xl select-none w-full overflow-x-hidden flex xs:flex-wrap justify-center items-center gap-3 p-3"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
          >
            <AnimatedCursor
              innerSize={10}
              outerSize={24}
              color="66, 165, 245"
              outerAlpha={0.2}
              innerScale={0.7}
              outerScale={2.1}
              clickables={[
                "a",
                'input[type="text"]',
                'input[type="email"]',
                'input[type="number"]',
                'input[type="submit"]',
                'input[type="image"]',
                "label[for]",
                "select",
                "textarea",
                "button",
                ".button",
                ".link",
              ]}
            />
            <PhotoSection />
            <motion.div
              className="flex w-full flex-col gap-2"
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <Menu />
              <ReactParallaxTilt
                tiltMaxAngleX={1}
                tiltMaxAngleY={1}
                className="border min-w-[280px] bg-gradient-to-br from-stone-800 via-black to-zinc-800 rounded-xl text-white border-gray-500"
              >
                <Routes className="flex-grow  ">
                  <Route
                    path="/"
                    element={
                      <motion.div>
                        <About />
                      </motion.div>
                    }
                  />
                  <Route
                    path="/projects"
                    element={
                      <motion.div>
                        <Projects />
                      </motion.div>
                    }
                  />
                  <Route
                    path="/projects/:projectName"
                    element={
                      <motion.div>
                        <ProjectDetails />
                      </motion.div>
                    }
                  />
                  <Route
                    path="/contact"
                    element={
                      <motion.div>
                        <Contact />
                      </motion.div>
                    }
                  />
                  <Route
                    path="/achievements"
                    element={
                      <motion.div>
                        <Achievements />
                      </motion.div>
                    }
                  />
                </Routes>
              </ReactParallaxTilt>
            </motion.div>
          </motion.div>
        </div>
      )}
    </div>
  );
}

export default App;
